import { Box } from "@mui/material"
import { BadgeLabel } from "routes/regime/plugins/regime-title/badge-label"

const STATUS = {
    draft: { color: "info", label: "Draft" },
    published: { color: "success", label: "Published" },
    retired: { color: "warning", label: "Retired" },
}

export function CustomScheduleStatusTag({ isDraft = true, status = isDraft ? "draft" : "published" }) {
    const { color, label } = STATUS[status] ?? STATUS.draft
    return (
        <Box flex={1} sx={{ zoom: 0.8, ml: 1.5 }}>
            <BadgeLabel color={color} badgeContent={label} />
        </Box>
    )
}
